// extracted by mini-css-extract-plugin
module.exports = {"container":"_1a06t5B6UEGlTbqpNR6yBd"};